import { computed } from 'mobx';

export default class MetaDataModel {
  id;
  store;

  constructor(store, metaData) {
    this.store = store;
    this.id = +metaData.id;
    this.name = metaData.name;
    this.caption = metaData.caption;
    this.description = metaData.description;
    this.seq = metaData.seq;
  }

  @computed get asJson() {
    return {
      id: +this.id,
      name: this.name,
      caption: this.caption,
      description: this.description,
      seq: this.seq,
    };
  }

  updateFromJson(json) {
    this.id = +json.id;
    this.name = json.name;
    this.caption = json.caption;
    this.description = json.description;
    this.seq = json.seq;
  }
}



// WEBPACK FOOTER //
// ./src/models/MetaDataModel.js